// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control-panel-interval {
  -webkit-appearance: none;
  position: absolute;
  height: 20px;
  margin: 0px 0;
  width: 33%;
  left: 52.5%;
  cursor: ew-resize;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.control-panel-interval .control-panel-interval-handle {
  position: absolute;
  height: 20px;
  min-width: 1px;
}

.control-panel-interval-dragging * {
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;

  cursor: ew-resize !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/interval.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,iBAAiB;;EAEjB,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,mCAAmC;EACnC,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;;EAE5B,4BAA4B;AAC9B","sourcesContent":[".control-panel-interval {\n  -webkit-appearance: none;\n  position: absolute;\n  height: 20px;\n  margin: 0px 0;\n  width: 33%;\n  left: 52.5%;\n  cursor: ew-resize;\n\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.control-panel-interval .control-panel-interval-handle {\n  position: absolute;\n  height: 20px;\n  min-width: 1px;\n}\n\n.control-panel-interval-dragging * {\n  -webkit-touch-callout: none !important;\n  -webkit-user-select: none !important;\n  -khtml-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n\n  cursor: ew-resize !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
